import React, { useEffect, useState } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTechnicianModel } from "../../technicianModel";
import { ITechnicianDetail } from "../../technicianTypes";
import moment, { Moment } from "moment";
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
export function DataTable() {
    const {
        dataDetSource, selectedDetRowKeys, pgDetCfg, descDetRows, initDetPgCfg,
        loadDetData, setSelectedDetRowKeys, setDescDetRows, setSearchDetParam
    } = useTechnicianModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const onLook = (record: ITechnicianDetail) => {
        let { maintenanceCode, tradeTypeCode } = record
        replaceNav(selectedNavId, "2-2-3", { id: maintenanceCode as string, mode: "look", }, true);
    }
    const columns: ColumnsType<ITechnicianDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            // title: '单据编号',
            title: Locale["Document No."],
            width: 150,
            dataIndex: 'maintenanceCode',
            fixed: "left",
            render: (text, record) => <span onClick={() => onLook(record)} className="click-span">{text}</span>
        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            width: 180,
            dataIndex: 'createTime',
            ellipsis: true,
        }, {
            // title: '维修人员',
            title: Locale["Technician"],
            width: 150,
            dataIndex: 'technicianName',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '工时',
            title: Locale["Man-hours"],
            width: 100,
            dataIndex: 'workHour',
        }, {
            // title: '工时费',
            title: Locale["Labor Cost"],
            width: 130,
            dataIndex: 'receivableAmount',
        }, {
            // title: '提成',
            title: Locale["Percentage"],
            width: 130,
            dataIndex: 'commission',
        },
    ];


    useEffect(() => {
        let { parentInfo } = detailsInfo
        loadDetData(initDetPgCfg, parentInfo)
        setSearchDetParam({ ...parentInfo })
    }, [])

    //点击行选高亮
    const onRow = (record: ITechnicianDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descDetRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descDetRows];
        let newSelectedRowKeys = [...selectedDetRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescDetRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedDetRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescDetRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedDetRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: ITechnicianDetail[]) => {
                    setSelectedDetRowKeys(selectedRowKeys as string[]);
                    setDescDetRows(selectedRows)
                },
                selectedRowKeys: selectedDetRowKeys
            }}
            columns={columns}
            dataSource={dataDetSource}
            pagination={{
                ...pgDetCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgDetCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadDetData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
